// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__XZNjo","button":"styles_button__5W8PF","text":"styles_text__OCo0A"};